export default __webpack_public_path__ + "static/icon_share2.6764092845afda255a234b6763387968.png";